import React, { useState, useRef, useEffect } from 'react';
import * as S from './style';
import { DefaultInputMaxLength } from '../../../constant-data/splashverse-onboarding';

const InputWithFloatingLabel = ({labelText, placeholderText, helperMessage, maxLength, submitHandler, inputType="text", onChangeHandler, required, shouldFocus=false, adjustWithContainer=false, isError=false, onFocusHandler, inputTextColor, validInputField=false, adjustWithContainerHeight=false, takeInputOnlyNumber}) => {

  const [fieldValue, setFieldValue] = useState('');
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const inputRef = useRef(null);
  const onFieldChangeHandler = (e) => {
    const value = e.target.value;

    if(onChangeHandler){
      if(takeInputOnlyNumber)
      {
        if(value.match((/^[0-9]+$/)) || value=="") {
          setFieldValue(e.target.value);
          return onChangeHandler(value);
        }
      }
      else {
      setFieldValue(e.target.value);
      return onChangeHandler(value);
      }
    }
    else{
      const regex = /^[a-zA-Z0-9 ]+$/; //this will admit letters, numbers and space
      if (value.match(regex) != null || value === "") {
        setFieldValue(e.target.value);
      }
    }
  
  }

  const validateAndSubmitField = (e) => {
    e && e.preventDefault();
    inputRef.current.blur();
    if (fieldValue && fieldValue.match(/^[a-zA-Z0-9 ]+$/)) {
      setSubmitSuccess(true);
      setTimeout(() => {
        submitHandler(fieldValue);
      }, 1000)
    }
  }

  useEffect(() => {
    setTimeout(() => {
      shouldFocus && inputRef?.current?.focus();
    }, 3000)
  }, [])

  useEffect(()=>{
    isError && inputRef?.current?.focus();
  },[isError])

  useEffect(()=>{
    setSubmitSuccess(validInputField);
  },[validInputField])

  return (
    <S.InputWrapper onSubmit={(e) => validateAndSubmitField(e)} adjustWithContainer = {adjustWithContainer} adjustWithContainerHeight = {adjustWithContainerHeight}>
      <S.TextField
        ref={inputRef}
        readOnly={false} 
        onChange={(e) => onFieldChangeHandler(e)} 
        type={inputType} 
        spellCheck="false" 
        placeholder={placeholderText} 
        autocorrect="off"
        value={fieldValue}
        maxLength={typeof(maxLength) !== 'undefined' ? maxLength : DefaultInputMaxLength}
        success={submitSuccess}
        required={required}
        adjustWithContainer = {adjustWithContainer}
        isError={isError}
        onFocus = {onFocusHandler}
        inputTextColor = {inputTextColor}
        validInputField = {validInputField}
        adjustWithContainerHeight = {adjustWithContainerHeight}
        />
      { submitHandler && <S.Icon notEmpty={fieldValue} onClick={validateAndSubmitField} success={submitSuccess}>
        <i className={'iconcust-iconBackBtn'} />
        </S.Icon> 
      }
      <S.Label htmlFor="" isError={isError} validInputField = {validInputField}>{labelText}</S.Label>
      { helperMessage &&
        <S.HelperMessage>{helperMessage}</S.HelperMessage>
      }
    </S.InputWrapper>
  )
}

export default InputWithFloatingLabel;